module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_0831_pine_green.bef670f0.jpg";